const DEFAULT_GAME_CARD_SIZES = {
	"1x1": {
		width: "136px",
		height: "106px",
		tabletWidth: "170px",
		tabletHeight: "140px",
		wideDesktopWidth: "170px",
		wideDesktopHeight: "140px",
		overlayWidth: "100%",
		overlayHeight: "106px",
		overlayWideDesktopWidth: "170px",
		overlayWideDesktopHeight: "140px",
	},
	"2x1": {
		width: "282px",
		height: "106px",
		tabletWidth: "350px",
		tabletHeight: "140px",
		wideDesktopWidth: "350px",
		wideDesktopHeight: "140px",
		overlayWidth: "100%",
		overlayHeight: "106px",
		overlayWideDesktopWidth: "350px",
		overlayWideDesktopHeight: "140px",
	},
	"1x2": {
		width: "136px",
		height: "252px",
		tabletWidth: "170px",
		tabletHeight: "320px",
		wideDesktopWidth: "170px",
		wideDesktopHeight: "320px",
		overlayWidth: "100%",
		overlayHeight: "252px",
		overlayWideDesktopWidth: "170px",
		overlayWideDesktopHeight: "320px",
	},
	"2x2": {
		width: "282px",
		height: "252px",
		tabletWidth: "350px",
		tabletHeight: "320px",
		wideDesktopWidth: "350px",
		wideDesktopHeight: "320px",
		overlayWidth: "100%",
		overlayHeight: "252px",
		overlayWideDesktopWidth: "350px",
		overlayWideDesktopHeight: "320px",
	},
};

const CHOKWIN_GAME_CARD_SIZES = {
	"1x1": {
		width: "140px",
		height: "80px",
		tabletWidth: "140px",
		tabletHeight: "80px",
		wideDesktopWidth: "140px",
		wideDesktopHeight: "80px",
		overlayWidth: "100%",
		overlayHeight: "80px",
		overlayWideDesktopWidth: "140px",
		overlayWideDesktopHeight: "80px",
	},
	"2x1": {
		width: "290px",
		height: "80px",
		tabletWidth: "290px",
		tabletHeight: "80px",
		wideDesktopWidth: "290px",
		wideDesktopHeight: "80px",
		overlayWidth: "100%",
		overlayHeight: "80px",
		overlayWideDesktopWidth: "290px",
		overlayWideDesktopHeight: "80px",
	},
	"1x2": {
		width: "140px",
		height: "190px",
		tabletWidth: "140px",
		tabletHeight: "190px",
		wideDesktopWidth: "140px",
		wideDesktopHeight: "190px",
		overlayWidth: "100%",
		overlayHeight: "190px",
		overlayWideDesktopWidth: "140px",
		overlayWideDesktopHeight: "190px",
	},
	"2x2": {
		width: "290px",
		height: "190px",
		tabletWidth: "290px",
		tabletHeight: "190px",
		wideDesktopWidth: "290px",
		wideDesktopHeight: "190px",
		overlayWidth: "100%",
		overlayHeight: "190px",
		overlayWideDesktopWidth: "290px",
		overlayWideDesktopHeight: "190px",
	},
};

export const getTenantCardSizes = () => {
	const tenant = window.TENANT;

	if (tenant === "chokwin") {
		return CHOKWIN_GAME_CARD_SIZES;
	}

	return DEFAULT_GAME_CARD_SIZES;
};
